module.exports = require("@cimpress/react-components/lib/colors");